import React from "react";
import { Form, Card } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { Field } from "./Field";
import { CommissionStatus } from "./constants";
import { SubmitButton } from "../shared";

// Uncontrolled form: `params` seed the defaults, values are read from FormData
// on submit and handed up via `onSearch`.
export function SearchForm({ params, onSearch }) {
  const { searchTerm, commissionStatus, signedStartDate, signedEndDate } =
    params;

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    onSearch(
      data.get("searchTerm"),
      data.get("status"),
      data.get("signedStartDate"),
      data.get("signedEndDate"),
    );
  };

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        {/* key remounts the form (and its defaultValues) when the URL changes */}
        <Form
          key={`${searchTerm}|${commissionStatus}|${signedStartDate}|${signedEndDate}`}
          onSubmit={handleSubmit}
          className="commission-search-form"
        >
          <div className="d-flex flex-wrap align-items-end gap-3">
            <Field
              label="Signed from"
              className="commission-field commission-field--date"
            >
              <Form.Control
                name="signedStartDate"
                type="date"
                defaultValue={signedStartDate}
                className="commission-input"
              />
            </Field>

            <Field
              label="Signed to"
              className="commission-field commission-field--date"
            >
              <Form.Control
                name="signedEndDate"
                type="date"
                defaultValue={signedEndDate}
                className="commission-input"
              />
            </Field>

            <Field
              label="Search"
              className="commission-field commission-search-field"
            >
              <Form.Control
                name="searchTerm"
                type="search"
                placeholder="Contract #, purchaser, agent…"
                defaultValue={searchTerm}
                className="commission-input commission-search-input"
              />
            </Field>

            <Field
              label="Commission Status"
              className="commission-field commission-field--status"
            >
              <Form.Select
                name="status"
                defaultValue={commissionStatus}
                className="commission-input"
              >
                {Object.values(CommissionStatus).map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
                <option value="">All</option>
              </Form.Select>
            </Field>

            <div className="commission-search-actions">
              <SubmitButton
                type="submit"
                text="Search"
                color="blue"
                icon={<Search size={17} />}
              />
            </div>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
